import { FC } from 'react';

import LogoSVG from '../../../../assets/icons/logo.svg';
import { Divider, Typography } from '../../../../designComponents';
import { useResponsive } from '../../../../hooks/useResponsive';
import { MainHeadStyled } from './style';

interface MainHeadPropsTypes {
  city: string;
  country: string;
  postalCode: string;
  invoiceNumber: string;
  date: string;
  invoiceDueDate: string;
  email: string;
}

const MainHead: FC<MainHeadPropsTypes> = ({
  city,
  country,
  postalCode,
  invoiceNumber,
  invoiceDueDate,
  email,
  date,
}) => {
  const { isTablet } = useResponsive();
  return (
    <MainHeadStyled>
      <div className="logo-wrapper">
        <img src={LogoSVG} alt="logo" width={45} height={45} />
        <div className="plans">
          <Typography>Evacuation Plans</Typography>
          <Typography>SaaS Application</Typography>
        </div>
      </div>
      <div className="head-data">
        <div className="head-data-main">
          <Typography fontColor="border">{email}</Typography>
          <Typography>City: {city}</Typography>
          <Typography>Country: {country}</Typography>
          <Typography>Postal Code: {postalCode}</Typography>
        </div>
        {!isTablet && <Divider />}
        <div className="head-data-due">
          <Typography>Invoice Number: {invoiceNumber}</Typography>
          <Typography>Date: {date}</Typography>
          <Typography>Invoice Due Date: {invoiceDueDate}</Typography>
        </div>
      </div>
    </MainHeadStyled>
  );
};

export default MainHead;
